<div class="redesign-content-container">
    <div class="scrollable-content landingpageWrapper">
        <div fxLayout="row" fxLayoutAlign="center start">
            <div fxLayout="column" class="signup-success" fxLayoutGap="2rem">
                <div class="align-center clarevision-logo" fxLayout="row">
                    <img src="assets/images/signup/clarevision_blue_logo.svg" alt="ClareVision logo" />
                </div>
                <div class="align-center title" fxLayout="row"><p>Start managing your system with the app.</p></div>
                <div class="align-center download-app" fxLayout="row">
                    <p>Download the ClareHome App from the App Store or Google Play store.</p>
                </div>
                <div class="align-center ios-app" fxLayout="row">
                    <a target="_blank" href="https://apps.apple.com/us/app/clarehome/id545640364"
                        ><img src="assets/images/signup/app_store.png" alt="Download on the App Store"
                    /></a>
                </div>
                <div class="align-center android-app" fxLayout="row">
                    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.clarecontrols.kraken&hl=en_US">
                        <img src="assets/images/signup/google.png" alt="Get it on Google Play"
                    /></a>
                </div>
            </div>
        </div>
    </div>
</div>
